let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cz5Vg")).then(() => parcelRequire('7yjbB'));